import { ChatAssistant } from '../../types'

export default function MessageLink({
  href,
  assistant,
  children
}: {
  href: string
  assistant?: ChatAssistant
  children: React.ReactNode
}) {
  const message = href.match(/^#message:(.*)$/)?.[1]

  return (
    <a
      href={href}
      onClick={event => {
        event.preventDefault()
        event.stopPropagation()
        if (message && assistant) {
          const decodedMessage = decodeURIComponent(message)
          void assistant.send(decodedMessage)
        }
      }}
    >
      {children}
    </a>
  )
}
